/**
 * Simple platform detection utilities
 */

export function isIOSDevice(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
}

export function isAndroidDevice(): boolean {
  return /Android/.test(navigator.userAgent);
}

export function isMobileDevice(): boolean {
  return isIOSDevice() || isAndroidDevice();
}

export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  // navigator.platform is deprecated but still the most reliable synchronous check.
  // Treat iPad/iPhone as Mac for modifier-key display (Cmd).
  return /Mac|iPad|iPhone|iPod/.test(navigator.platform);
}
